export const colors = {
  'primary-SIAblack': '#000000',
  'primary-SIAgrayDark': '#4c4c4c',
  'primary-SIAgrayMiddle': '#a8a8a8',
  'primary-SIAgray': '#d4d4d4',
  'primary-SIAgrayLight': '#e8e8e8',
  'primary-SIAgrayVeryLight': '#f4f4f4',
  'primary-SIAwhite': '#fff',
  'primary-SIAred': '#e41b13',
  'primary-SIAredDark': '#99100a',
  'secondary-SIAazure': '#8caddb',
  'secondary-SIAazureLight': '#e9eff7',
  'secondary-SIAbronze': '#b1997e',
  'secondary-SIAbronzeLight': '#efebe5',
  'secondary-SIAgreen': '#2fb789',
  'secondary-SIAgreenLight': '#ecf7f3',
  'secondary-SIAorange': '#f3743d',
  'secondary-SIAorangeLight': '#fbf1ec',
  'secondary-SIArose': '#e6005f',
  'secondary-SIAroseLight': '#fcf2f7',
  'secondary-SIAyellow': '#dacd7e',
  'secondary-SIAyellowLight': '#faf8ed'
};
export const getColor = color => {
  const colorArray = Object.entries(colors)?.find(el => el[0].includes(color));
  return colorArray ? colorArray[1] : color;
};